import { render, staticRenderFns } from "./LogisticaView.vue?vue&type=template&id=11a7978a"
import script from "./LogisticaView.vue?vue&type=script&lang=js"
export * from "./LogisticaView.vue?vue&type=script&lang=js"
import style0 from "./LogisticaView.vue?vue&type=style&index=0&id=11a7978a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports